@let webSubscriptions = webSubscriptions$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    <ion-title>My Subscriptions</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  @if (webSubscriptions && !webSubscriptions.length) {
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">
      You have no subscriptions to display. Purchase a subscription and come back here to view it.
    </ion-note>
  </div>
  }
  <ion-list [inset]="false" lines="full">
    @for (webSubscription of webSubscriptions; track webSubscriptionsListTrackBy($index, webSubscription)) {
    <ion-item-sliding>
      <ion-item>
        <ion-label>
          <div class="tw:flex tw:items-center">
            <ion-text color="primary" class="tw:text-md tw:font-bold">
              {{webSubscription.items[0].product.name}}
            </ion-text>
            <ion-badge class="tw:ml-2 tw:capitalize">{{webSubscription.status}}</ion-badge>
          </div>
          <ion-text color="medium" class="tw:text-xs">{{webSubscription.items[0].product.description}}</ion-text><br />
          @if (webSubscription.canceled_at) {
          <ion-text color="danger" class="tw:text-xs">Cancels at: </ion-text>
          <ion-text color="medium" class="tw:text-xs tw:font-bold">
            {{webSubscription.cancel_at * 1000 | date: 'MM/dd/yyyy'}}
          </ion-text>
          } @else {
          <ion-text color="primary" class="tw:text-xs">Renews at: </ion-text>
          <ion-text color="medium" class="tw:text-xs tw:font-bold">
            {{webSubscription.current_period_end * 1000 | date: 'MM/dd/yyyy'}}
          </ion-text>
          }
        </ion-label>
        @if (!webSubscription.canceled_at) {
        <ion-button color="danger" slot="end" shape="round" (click)="cancelSubscription(webSubscription)">
          <ion-icon name="close-circle-outline" slot="icon-only"> </ion-icon>
        </ion-button>
        }
      </ion-item>
    </ion-item-sliding>
    }
  </ion-list>
</red-page-content>
